import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Modal } from '@softline/ui-core';
import { Artstamm } from '../../types/artstamm';
import { LoadArchiveFilePipe } from '../../pipes/load-archive-file.pipe';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'soft-image-viewer-dialog',
    templateUrl: './image-viewer-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        LoadArchiveFilePipe,
        AsyncPipe
    ],
    styleUrls: ['./image-viewer-dialog.component.scss']
})
export class ImageViewerDialogComponent implements OnInit, Modal<any> {

  artstamm!: Artstamm;

  close!: (result: any) => void;

  constructor() { }

  ngOnInit(): void {}

  registerCloseHandler(handler: (result: any) => void) {
    this.close = handler;
  }
}
